import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import Navbar from "@/components/Navbar";
import { api } from "@/lib/api";
import { toast } from "sonner";

export default function EditGroup() {
  const { groupId } = useParams();
  const navigate = useNavigate();
  const [group, setGroup] = useState(null);
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [rules, setRules] = useState("");
  const [image, setImage] = useState("");
  const [joinCost, setJoinCost] = useState(0);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get(`/groups/${groupId}`).then(res => {
      const g = res.data;
      setGroup(g);
      setTitle(g.title);
      setDescription(g.description);
      setRules(g.rules);
      setImage(g.image);
      setJoinCost(g.join_cost);
    }).finally(() => setLoading(false));
  }, [groupId]);

  const handleSave = async () => {
    try {
      await api.put(`/groups/${groupId}`, { title, description, rules, image, join_cost: joinCost });
      toast.success("Group updated");
      navigate(`/groups/${groupId}`);
    } catch (err) {
      toast.error(err.response?.data?.detail || "Update failed");
    }
  };

  if (loading) return <div className="min-h-screen"><Navbar /><div className="p-8 text-center">Loading...</div></div>;

  return (
    <div className="min-h-screen bg-[#FAFAF7]">
      <Navbar />
      <main className="max-w-xl mx-auto px-4 py-8">
        <h1 className="font-display text-2xl font-semibold mb-6">Edit Group</h1>
        <div className="bg-white border rounded-2xl p-6 space-y-4">
          {/* Similar fields as CreateGroup, but pre-filled */}
          <div>
            <label className="text-xs font-semibold uppercase">Title</label>
            <input value={title} onChange={e => setTitle(e.target.value)} className="neo-input mt-1" />
          </div>
          <div>
            <label className="text-xs font-semibold uppercase">Description</label>
            <textarea value={description} onChange={e => setDescription(e.target.value)} className="neo-input mt-1 h-24" />
          </div>
          <div>
            <label className="text-xs font-semibold uppercase">Rules</label>
            <textarea value={rules} onChange={e => setRules(e.target.value)} className="neo-input mt-1 h-24" />
          </div>
          <div>
            <label className="text-xs font-semibold uppercase">Join Cost</label>
            <input type="number" value={joinCost} onChange={e => setJoinCost(Math.max(0, parseInt(e.target.value) || 0))} className="neo-input mt-1" />
          </div>
          <div>
            <label className="text-xs font-semibold uppercase">Image</label>
            <input type="file" accept="image/*" onChange={(e) => {
              const file = e.target.files[0];
              if (file) {
                const reader = new FileReader();
                reader.onload = () => setImage(reader.result);
                reader.readAsDataURL(file);
              }
            }} />
            {image && <img src={image} className="mt-2 w-20 h-20 rounded-xl object-cover" />}
          </div>
          <button onClick={handleSave} className="neo-btn bg-purple-600 border-purple-600 w-full">Save Changes</button>
        </div>
      </main>
    </div>
  );
}